module.exports = __webpack_public_path__ + "static/FlutterDesigns-a197d6c9dc1a6ad26d4d9448b8809b7a.jpg";